export function summaryCardRows(summaryRows) {
    return summaryRows.map((summary)=>({
            id: summary.id,
            label: summary.label.text,
            caption: summary.label.caption,
            value: summary.amount.text,
            weight: summary.weight,
            entering: summary.entering === true
        }));
}
